import React from 'react'
import Register from './components/register'
import logo from './logo.png'
import {register} from '../../actions'

export default class SignUpPage extends React.Component {
  render () {
    return (
      <div>
        <img style={{'display': 'block', 'maxWidth': '60%', 'margin': '2em auto'}} src={logo} alt='Factoripad' />
        <Register register={register} />
        <div style={{textAlign: 'center'}}>
          <a href='https://www.risqover.com'> Go to homepage </a>
          | <a href='/auth'> Go to login page </a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/index.js